import { useDrop } from 'react-dnd';
import { NativeTypes } from 'react-dnd-html5-backend';

import Box from 'shared_DEPRECATED/components/Box/Box';

import { Typography } from 'shared/components/Typography';

type ChatDragAndDropPopoverProps = {
  children: React.ReactNode;
  onDrop: (file: File) => void;
};

export const ChatDragAndDropPopover = ({
  children,
  onDrop,
}: ChatDragAndDropPopoverProps) => {
  const [{ canDrop, isOver }, drop] = useDrop(
    () => ({
      accept: [NativeTypes.FILE],
      canDrop() {
        return true;
      },
      drop(item: { files: File[] }) {
        if (onDrop) {
          onDrop(item.files[0]);
        }
      },
      collect: (monitor) => {
        return {
          isOver: monitor.isOver(),
          canDrop: monitor.canDrop(),
        };
      },
    }),
    [onDrop]
  );
  const isActive = canDrop && isOver;

  return (
    <Box
      ref={drop}
      style={{
        position: 'relative',
        height: '100%',
      }}
    >
      <Box
        style={{
          zIndex: 2,
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: isActive ? 'flex' : 'none',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        }}
      >
        <Typography color="white" type="meta">
          Release to drop
        </Typography>
      </Box>
      {children}
    </Box>
  );
};
